export default __webpack_public_path__ + "static/2-78d2da114cdf63543f280ed68432e2e9.jpeg";